export default class Modal {
    constructor() {
        this.init();
    }

    init() {
        this.modal();
    }

    modal() {
        const $openArray = [...document.querySelectorAll('.js-modal_open')];
        const $modal = document.querySelector('.c-modal');
        const $inner = $modal.querySelector('.c-modal__inner');
        const $close = $modal.querySelector('button');

        $openArray.forEach(($opener) => {
            $opener.addEventListener('click', (e) => {
                e.stopPropagation();

                const src = $opener.dataset.src;
                const type = $opener.dataset.type;

                if (type === 'youtube') {
                    let tagstr = `<div class="c-modal_movie__iframewrap"><iframe src="//www.youtube.com/embed/${src}?autoplay=1&mute=1&playsinline=1" title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
                    $inner.innerHTML = tagstr;
                } else {
                    $inner.innerHTML = `<img src="${src}">`;

                    const $img = $inner.querySelector('img');
                    $img.addEventListener('load', () => {
                        $img.height > 890 ? $inner.classList.add('-vertical') : $inner.classList.remove('-vertical');
                    });
                }

                $modal.classList.add('-active');
            });
        });

        $close.addEventListener('click', () => {
            $modal.classList.remove('-active');
            $inner.innerHTML = '';
        });
    }
}
